import { AssignmentSubmissionResponse, StudentAssignmentResponse } from "shared/types/studentTypes"
import Table from "react-bootstrap/Table"
import { useLocation, useNavigate } from "react-router"
import { Link } from "react-router-dom"
import { LessonResponse } from "shared/lessons"
import { SubmissionStudentState } from "pages/Dashboard/Student/Grades/Submission/SubmissionStudent"
import { showGrade } from "./StudentGrades"
import { toast } from "react-toastify"
import { formatSubmissionStatus } from "helpers/submissionsHelper"

/**
 * Location state properties that this page is expecting when being redirected here
 */
export class StudentSubmissionsState {
    constructor() {
        this.previousPage = ".."
        this.currentIndex = 1
        this.lesson = null
    }
    assignment: StudentAssignmentResponse
    studentId: string
    lesson?: LessonResponse
    previousPage?: string
    currentIndex?: number
}

export default function Submissions() {
    const location = useLocation()
    const navigate = useNavigate()
    const state = location.state as StudentSubmissionsState

    const navigateToSubmission = (submission: AssignmentSubmissionResponse, index) => {
        if (submission.status === "graded" || submission.status === "rework-required" || submission.status === "rejected") {
            navigate("/dashboard/student/grades/submission", {
                state: {
                    currentIndex: index,
                    assignment: state.assignment,
                    submission: submission,
                    studentId: state.assignment.studentId,
                    userType: "Student",
                    previousPage: "/dashboard/student/grades/submissions",
                } as SubmissionStudentState
            })
        } else {
            toast.error("This submission is not graded yet.")
        }
    }

    return <>
        <h1 className="h2 text-start mt-3">{state.assignment?.title ?? ""} Submissions</h1>
        <div className="text-start mb-3">
            <Link className="text-decoration-none" to={state.previousPage ?? "/dashboard/student/grades"}>
                <i className="fas fa-arrow-left pe-2" />
                <span>Return to Grade List</span>
            </Link>
        </div>
        <Table hover>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Overall Grade</th>
                    <th>Completed</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {state.assignment.submissions.map((submission, index) => (<>
                        <tr role={submission && "button"} onClick={() => navigateToSubmission(submission, index)}>
                            <td>{index + 1}</td>
                            <td>{showGrade({gradeType: "overall", submission: submission, assignment: state.assignment, showRecentLabel: true })}</td>
                            <td>{submission.dateSubmitted ? new Intl.DateTimeFormat().format(new Date(submission.dateSubmitted)) : "Not Completed"}</td>
                            <td>{formatSubmissionStatus(submission.status)}</td>
                        </tr>
                    </>
                ))}
            </tbody>
        </Table>
    </>
}
